export default "__VITE_ASSET__DYXQjUmc__"